<div class="grid-container padding-y-4">
  <div class="grid-row grid-gap">
    <div class="grid-col-5">
      @if ((checkUserRole(agency_user) || checkUserRole(agency_admin)|| checkUserRole(carrier_user_admin) || checkUserRole(carrier_user_RF) || checkUserRole(carrier_user))) {
        <legend class="usa-legend usa-legend--large">XTOS Shipment Reports</legend>
      }
      @if ((checkUserRole(system_admin))) {
        <legend class="usa-legend usa-legend--large">XTOS Comprehensive Shipment Reports</legend>
      }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-3">
      <p>ERRC requires TSPs to submit Shipment Reports within 60 calendar days after the quarter in which a shipment was invoiced. Because of this delay in reporting, shipments displayed for a selected Reporting Calendar Year/Reporting Quarter may not have been booked/delivered during the year/quarter queried.</p>
    </div>
  </div>

  <form id="sitComprehensiveFormGroup" role="form" [formGroup]="xtosComprehensiveFormGroup"
    (ngSubmit)="getSITCompresensiveDetails()">
    <div class="grid-row grid-gap">
      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="reportingYrSelect">Reporting Calender Year<abbr title="required"
        class="usa-hint usa-hint--required">*</abbr></label>
        <select id="reportingYrSelect" class="usa-select width-full" formControlName='reportingYrSelect'
          (change)="onReportYrChange($event.target.value)">
          <option hidden value=''>Choose...</option>
          @for (reportingYrSingle of reportingYrList; track reportingYrSingle) {
            <option [value]="reportingYrSingle.value">
            {{reportingYrSingle.name}}</option>
          }
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
        <label class="usa-label" for="reportingQtrSelect">Reporting Quarter</label>
        <select id="reportingQtrSelect" class="usa-select width-full" formControlName='reportingQtrSelect'
          (change)="onReportQtrChange($event.target.value)">
          <option hidden value=''>Choose...</option>
          <option value='0'>All Quarters</option>
          <option value='1'>Quarter 1 (January - March)</option>
          <option value='2'>Quarter 2 (April - June)</option>
          <option value='3'>Quarter 3 (July - September)</option>
          <option value='4'>Quarter 4 (October - December)</option>
        </select>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-y-4">
        <button type="button" class="usa-button" [disabled]="this.xtosComprehensiveFormGroup.invalid"
        type="submit">Search</button>
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12 padding-bottom-205">
        <img src="assets/uswds/img/usa-icons/file_download.svg" alt="user_icon"> Right click on the report and select the appropriate options to export.
      </div>

      <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
        <ag-grid-angular class="ag-theme-alpine" [columnDefs]="xtosComprensivecolumnDefs" [gridOptions]="gridOptions"
          [rowData]="rowData" [excelStyles]="excelStyles" [suppressDragLeaveHidesColumns]="true"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </div>

    </div>
  </form>

</div>
